import React, {
  useState,
  useCallback,
  useEffect,
  useMemo,
  useContext,
} from "react";
import { IntlProvider, FormattedMessage } from "react-intl";
import { injectIntl, intlShape } from "react-intl";
import { AuthenticationContext } from "../AuthenticationContextProvider";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Favorites from "../../icon/favorites.svg";
import Back from "../../icon/arrow_sx.svg";

import { NavLink, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

const NavigationBar = (props) => {
  const [items, setItems] = useState(props.items);
  const { favorites, userOptions, apps } = useContext(AuthenticationContext);
  const numberFavorites = userOptions.numberFavorites || 5;
  const canRequestSamples = apps?.samples?.request !== false;
  const noRequest = !!window.LIBRARY_NO_REQUEST;
  const history = useHistory();
  const { type, category, order, back } = props;

  const orderHandler = useCallback((e) => {
    const id = e.target.value;
    if (id && id != 0) {
      history.push(`/${type.url}/${id}`);
    }
  });

  const categoryOrderHandler = useCallback((e) => {
    const id = e.target.value;
    if (id && id != 0) {
      history.push(`/${type.url}/${category.url}/${id}`);
    }
  });

  const handleGtmClick = () => {
    
      let obj= {
        event: 'request_sample',
        category: favorites.map(item => item.name.split(" ").pop()).join('|'),
        action: type.url,
        label: category.url,
        option: favorites.length
      };


      if(type.url && type.url.length > 0) {

      }
      window.sendToGTM && window.sendToGTM(obj)
  };



  return (
    <header className="navigation__header">
      <div className="navigation__wrapper">
        {back && (
          <div className="navigation__shadowWrapper">
            <div className="container">
              <div className="navigation__listWrapper">
                <button
                  className={"navigation__back"}
                  type="button"
                  onClick={() => history.goBack()}
                >
                  <img src={Back} className={"navigation__iconBack"} />
                  <FormattedMessage id={"label.back"} />
                </button>
              </div>
            </div>
          </div>
        )}

        {!back && (
          <>
            <div className="navigation__shadowWrapper">
            <div className="container">
              <div className={`navigation__listWrapper${noRequest ? ' navigation__listWrapper--no-request' : ''}`}>
                {!noRequest && (
                <div className="navigation__favorites">
                  <img className="icon__favorites" src={Favorites} />{" "}
                  <FormattedMessage id={"label.favorites.counter"} />{" "}
                  {favorites.length}/{numberFavorites}
                </div>
                )}
                {!(noRequest && items.length === 1) && (
                <ul className="navigation__list">
                  {items.map((item, i) => (
                    <NavLink
                      key={"item_nav_" + i}
                      to={`/${item.url}`}
                      className={"navigation__link navigation__link--type"}
                      activeClassName="active"
                    >
                      <FormattedMessage id={item.name} />
                    </NavLink>
                  ))}
                </ul>
                )}
                {!noRequest && <div className="navigation__summary">
                  {favorites.length > 0 && (userOptions.login !== "1" || canRequestSamples) ? (
                    <NavLink to={`/favorites`} className="">
                      <button
                        onClick={handleGtmClick}
                        className={
                          "favoritesSummary__btn favoritesSummary__btn--header"
                        }
                      >
                        <FormattedMessage id={"favorites.send.button"} />
                      </button>
                    </NavLink>
                  ) : (
                    <>
                      <span
                        data-tip
                        data-for="headerBtn"
                        className="wrapperTooltip"
                      >
                        <button
                          disabled
                          className={
                            "favoritesSummary__btn favoritesSummary__btn--header"
                          }
                        >
                          <FormattedMessage id={"favorites.send.button"} />
                        </button>
                        <ReactTooltip
                          className="tooltip__header"
                          id="headerBtn"
                          html={true}
                          type="light"
                          place="bottom"
                          effect="solid"
                          multiline={true}
                        >
                          {userOptions.login === "1" && !canRequestSamples
                            ? `<h3>${props.intl.formatMessage({ id: "favorites.no.permission.title" })}</h3><p>${props.intl.formatMessage({ id: "favorites.no.permission.description" })}</p>`
                            : props.intl.formatMessage({ id: "favorites.send.button.tooltip" })
                          }
                        </ReactTooltip>
                      </span>
                    </>
                  )}
                </div>}
              </div>
            </div>
            </div>
            <div className="container">
              <div className="navigation__options">
                <div>
                  {type && type.order && type.order.length > 0 && (
                    <div>
                      <span className="selectOrder__label">
                        <FormattedMessage id={"label.orderby"} />{" "}
                      </span>
                      <select
                        className="selectOrder"
                        value={order && order.url}
                        onChange={orderHandler}
                      >
                        <option value={0}>
                          {props.intl.formatMessage({ id: "label.seleziona" })}
                        </option>
                        {type.order.map((item, i) => (
                          <option key={"option_type" + i} value={item.url}>
                            {props.intl.formatMessage({ id: item.name })}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {category && category.order && category.order.length > 0 && (
                    <div className="navigation__selectOrder">
                      <span className="selectOrder__label">
                        <FormattedMessage id={"label.orderby"} />{" "}
                      </span>
                      <select
                        className="selectOrder"
                        value={order && order.url}
                        onChange={categoryOrderHandler}
                      >
                        {category.order.map((item, i) => (
                          <option key={"option_category" + i} value={item.url}>
                            {props.intl.formatMessage({ id: item.name })}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                <div>
                  {type && type.category && type.category.length > 0 && (
                    <ul className="navigation__category">
                      {type.category.map((item, i) => (
                        <NavLink
                          key={"category_link" + i}
                          to={`/${type.url}/${item.url}`}
                          className={"navigation__link"}
                          activeClassName="active"
                        >
                          <FormattedMessage id={item.name} />
                        </NavLink>
                      ))}
                    </ul>
                  )}
                </div>

                <div>
                  {
                    <ul className="download__list">
                      {type &&
                        type.downloads &&
                        type.downloads.map((item, i) => (
                          <li key={"download_link_" + i}>
                            <a className="download__link">
                              <FormattedMessage id={item.name} />
                            </a>
                          </li>
                        ))}
                    </ul>
                  }
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default injectIntl(NavigationBar);
